/* eslint-disable */
import Timekeeping from './index'
import View from './components/view.vue'
export default [
  {
    path: '/timekeeping',
    component: Timekeeping,
    props: (route) => ({
      user: route.params.user || route.query.user,
    })
  },
]
